/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Deleteconfirm1Inputs */

const he_posts_deleteconfirm1 = /** @type {(inputs: Posts_Deleteconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האם אתה בטוח שברצונך למחוק פוסט זה?`)
};

const en_posts_deleteconfirm1 = /** @type {(inputs: Posts_Deleteconfirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this post?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this post?" |
*
* @param {Posts_Deleteconfirm1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_deleteconfirm1 = /** @type {((inputs?: Posts_Deleteconfirm1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Deleteconfirm1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_deleteconfirm1(inputs)
	return en_posts_deleteconfirm1(inputs)
});
export { posts_deleteconfirm1 as "posts_deleteConfirm" }